const initialState = [];

export const setReviewStateToStore = (state, { payload }) => [...payload];

export default initialState;
